import { TRANSFER_TO_BANK_SUCCESS } from "../actions/ActionConstant";
import { TOGGLE_BANK_ACCOUNT_MODAL } from "../actions/ActionConstant";
import { SET_MODAL_COMPONENT_TYPE } from "../actions/ActionConstant";
import { TRANSFER_TO_BANK_FAILED } from "../actions/ActionConstant";
import { TRANSFER_TO_BANK_START } from "../actions/ActionConstant";
import {
  ADD_BANK_ACCOUNT_START,
  ADD_BANK_ACCOUNT_SUCCESS,
  ADD_BANK_ACCOUNT_FAILURE,
  DELETE_BANK_ACCOUNT_START,
  DELETE_BANK_ACCOUNT_SUCCESS,
  DELETE_BANK_ACCOUNT_FAILURE,
  GET_BANK_ACCOUNT_START,
  GET_BANK_ACCOUNT_SUCCESS,
  GET_BANK_ACCOUNT_FAILURE,
  MAKE_DEFAULT_BANK_ACCOUNT_START,
  MAKE_DEFAULT_BANK_ACCOUNT_SUCCESS,
  MAKE_DEFAULT_BANK_ACCOUNT_FAILURE,
  FETCH_SINGLE_BANK_ACCOUNT_START,
  FETCH_SINGLE_BANK_ACCOUNT_SUCCESS,
  FETCH_SINGLE_BANK_ACCOUNT_FAILURE,
} from "../actions/ActionConstant";

const initialState = {
  addBankAccountInput: {
    data: {},
    loading: false,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  bankAccount: {
    data: {},
    loading: true,
    error: false,
  },
  deleteAccount: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
  },
  makeDefault: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
  },
  singleAccount: {
    data: {},
    loading: true,
    error: false,
    inputData: {},
  },
  bankTransfer: {
    data: {},
    loading: false,
    error: false,
    inputData: {},
    loadingButtonContent: null,
    buttonDisable: false,
  },
  bankAccountModal: {
    open: false,
    type: "list",
  },
  buttonDisable: false,
  loadingButtonContent: null,
};

const BankAccountReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_BANK_ACCOUNT_START:
      return {
        ...state,
        addBankAccountInput: {
          data: {},
          loading: true,
          error: false,
          inputData: action.data,
          loadingButtonContent: "Loading... Please wait",
          buttonDisable: true,
        },
      };
    case ADD_BANK_ACCOUNT_SUCCESS:
      return {
        ...state,
        addBankAccountInput: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
        bankAccountModal: {
          open: false,
          type: "list",
        },
      };
    case ADD_BANK_ACCOUNT_FAILURE:
      return {
        ...state,
        addBankAccountInput: {
          data: {},
          loading: true,
          error: action.error,
          inputData: {},
          loadingButtonContent: null,
          buttonDisable: false,
        },
      };
    case GET_BANK_ACCOUNT_START:
      return {
        ...state,
        bankAccount: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case GET_BANK_ACCOUNT_SUCCESS:
      return {
        ...state,
        bankAccount: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case GET_BANK_ACCOUNT_FAILURE:
      return {
        ...state,
        bankAccount: {
          data: {},
          loading: true,
          error: action.error,
        },
      };
    case DELETE_BANK_ACCOUNT_START:
      return {
        ...state,
        deleteAccount: {
          inputData: action.data,
          data: {},
          loading: true,
          error: false,
        },
      };
    case DELETE_BANK_ACCOUNT_SUCCESS:
      return {
        ...state,
        deleteAccount: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case DELETE_BANK_ACCOUNT_FAILURE:
      return {
        ...state,
        deleteAccount: {
          data: {},
          loading: true,
          error: action.error,
        },
      };
    case MAKE_DEFAULT_BANK_ACCOUNT_START:
      return {
        ...state,
        makeDefault: {
          inputData: action.data,
          data: {},
          loading: true,
          error: false,
        },
      };
    case MAKE_DEFAULT_BANK_ACCOUNT_SUCCESS:
      return {
        ...state,
        makeDefault: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
        },
      };
    case MAKE_DEFAULT_BANK_ACCOUNT_FAILURE:
      return {
        ...state,
        makeDefault: {
          data: {},
          loading: true,
          error: action.error,
          inputData: {},
        },
      };
    case FETCH_SINGLE_BANK_ACCOUNT_START:
      return {
        ...state,
        singleAccount: {
          inputData: action.data,
          data: {},
          loading: true,
          error: false,
        },
      };
    case FETCH_SINGLE_BANK_ACCOUNT_SUCCESS:
      return {
        ...state,
        singleAccount: {
          data: action.data,
          loading: false,
          error: false,
          inputData: {},
        },
      };
    case FETCH_SINGLE_BANK_ACCOUNT_FAILURE:
      return {
        ...state,
        singleAccount: {
          data: {},
          loading: true,
          error: action.error,
          inputData: {},
        },
      };
    case TRANSFER_TO_BANK_START:
      return {
        ...state,
        bankTransfer: {
          loading: true,
          buttonDisable: true,
          inputData: action.data,
          loadingButtonContent: "Transfering please wait...",
          error: false,
          data: {},
        },
      };
    case TRANSFER_TO_BANK_SUCCESS:
      return {
        ...state,
        bankTransfer: {
          loading: false,
          buttonDisable: false,
          inputData: {},
          loadingButtonContent: null,
          error: false,
          data: action.data,
        },
      };
    case TRANSFER_TO_BANK_FAILED:
      return {
        ...state,
        bankTransfer: {
          loading: false,
          buttonDisable: false,
          inputData: {},
          loadingButtonContent: null,
          error: action.error,
          data: {},
        },
      };
    case TOGGLE_BANK_ACCOUNT_MODAL:
      return {
        ...state,
        bankAccountModal: {
          open: !state.bankAccountModal.open,
          type: state.bankAccountModal.type === "bank" ? "list" : "list",
        },
      };
    case SET_MODAL_COMPONENT_TYPE:
      return {
        ...state,
        bankAccountModal: {
          open: state.bankAccountModal.open,
          type: action.data,
        },
      };

    default:
      return state;
  }
};

export default BankAccountReducer;
